import React, { useEffect } from 'react';
import TmuaLandingPage from '../../features/specialty/tmua';

export default function TmuaLandingRoute() {
  useEffect(() => {
    document.title = "TMUA Prep 2026/2027 — Cambridge, Imperial & LSE Admissions | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <TmuaLandingPage />;
}
